import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import styledComponent from "styled-components"

const StyledButtonGroup = styledComponent.span`
    &.horizontal {
        & > [role="button"]:first-of-type:not(:only-child) {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
        & > [role="button"]:last-of-type:not(:only-child) {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
        & > [role="button"]:not(:first-of-type):not(:last-of-type) {
            border-radius: 0px;
        }
        & > [role="button"]:not(:first-of-type):not(:only-child) {
            margin-left: -1px;
        }
    }
    &.vertical {
        display: flex;
        flex-direction: column;
        & > [role="button"]:first-of-type:not(:only-child) {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
        }
        & > [role="button"]:last-of-type:not(:only-child) {
            border-top-right-radius: 0;
            border-top-left-radius: 0;
        }
        & > [role="button"]:not(:first-of-type):not(:last-of-type) {
            border-radius: 0px;
        }
        & > [role="button"]:not(:first-of-type):not(:only-child) {
            margin-top: -1px;
        }
    }
`

/**
 *
 * @param {ButtonGroupType} props
 */
function ButtonGroup({ vertical = false, className = undefined, ...otherProps }) {
    const innerClasses = cx(className, { vertical, horizontal: !vertical })

    return <StyledButtonGroup className={innerClasses} {...otherProps} />
}

ButtonGroup.propTypes = {
    vertical: PropTypes.bool,
}

export default ButtonGroup



// WEBPACK FOOTER //
// ./src/ui/legacy/ButtonGroup.js